import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { DropdownOption } from 'shared-client/types/fields';
import { DropdownProps, FormDropdown } from '.';

export type MonthDropdownProps = FieldRenderProps<any, HTMLInputElement> &
	DropdownProps & {
		showMonthNames?: boolean;
	};

const months: string[] = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

/**
 * Component that renders a dropdown with months.
 *
 * @class MonthDropdown
 * @extends {React.Component<MonthDropdownProps>}
 */
class MonthDropdown extends React.Component<MonthDropdownProps> {
	private options: DropdownOption[];

	public static defaultProps: Partial<MonthDropdownProps> = {
		showMonthNames: true,
	};

	constructor(props) {
		super(props);

		this.options = months.map((month, index) => {
			const paddedNumber = `${index < 9 ? '0' : ''}${index + 1}`;
			return {
				value: paddedNumber,
				text: props.showMonthNames ? month : paddedNumber,
			};
		});
	}

	public render() {
		// eslint-disable-next-line no-unused-vars
		const { showMonthNames, ...rest } = this.props;

		return <FormDropdown {...rest} addSelectOption options={this.options} />;
	}
}

export default MonthDropdown;
